import { Component, OnInit } from '@angular/core';
import { AuthService, JwtPayload } from '../auth.service';
import { delay, timer } from 'rxjs';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'email-verification',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css']
})
export class EmailVerificationComponent implements OnInit{

  verified: boolean = false;
  emailCooldown: number = 60;
  emailSent: boolean = false;
  hashedEmail: { email: string }

  constructor(private authService: AuthService){}


   async resendEmailVerification(){
    let result = await this.authService.emailVerificationRequest();
    if(result){
      this.emailSent = true;
      this.authService.openSnackBar('Verification email has been sent','');
      const counter = timer(1000, 1000);
      const sub = counter.subscribe(tickValue =>{
        this.emailCooldown -= tickValue;
        if(tickValue === 60){
          this.emailSent = false;
          this.emailCooldown = 60;
          sub.unsubscribe();
        }
      });
    
      return;
    }
    this.authService.openSnackBar('There was an issue sending veriffication email','Please try again later');
  }
  async checkStatus(){
      const response = await this.authService.checkAccountStatus();
      const jwt: JwtPayload = this.authService.decodeToken(response.token);
      this.verified = jwt.verified;
      if(!jwt.verified){
        this.authService.storeAuthToken(response);
      }
  }
  async ngOnInit(): Promise<void> {
    this.hashedEmail = await this.authService.getUserHashedEmail();
  }

}
